import { appColors } from '../../../globalStyles'
import { hexToRGBA } from '@utils/colorConversions'

import get from 'lodash/get'
import some from 'lodash/some'

import { ChartTypes } from '../index'

const CHART_EVENT_POINT_RADIUS = 6
const CHART_EVENT_ERROR_POINT_RADIUS = 7

export const CHART_NAMES = {
  SCENARIO_FORECAST: "Scenario",
  ACTUAL_FORECAST: "Actual",
  EXPENSE_FORECAST: "Expense",
  INCOME_FORECAST: "Income",
}

export const buildDatasetConfig = (colors, enabledStatus, {
  isScenario,
  chartType
}) => {
  const sharedConfig = buildSharedConfig()

  const config = {
    [CHART_NAMES.SCENARIO_FORECAST]: {
      enabled: enabledStatus[CHART_NAMES.SCENARIO_FORECAST],
      label: chartType === ChartTypes.income ? 'Scenario net income' : 'Scenario capital',
      fill: false,
      borderColor: colors.secondaryTwoColor,
      backgroundColor: colors.secondaryTwoColor,
      borderWidth: 3,
      showCashflowEvents: true,
      ...sharedConfig
    },
    [CHART_NAMES.ACTUAL_FORECAST]: {
      enabled: enabledStatus[CHART_NAMES.ACTUAL_FORECAST],
      label: chartType === ChartTypes.income ? 'Actual net income' : 'Actual capital',
      fill: true,
      borderWidth: 0,
      backgroundColor: hexToRGBA(colors.secondaryOneColor, 0.3),
      borderColor: hexToRGBA(colors.secondaryOneColor, 0.3),
      showCashflowEvents: !enabledStatus[CHART_NAMES.SCENARIO_FORECAST],
      ...sharedConfig
    },
    [CHART_NAMES.INCOME_FORECAST]: {
      enabled: enabledStatus[CHART_NAMES.INCOME_FORECAST],
      label: isScenario ? 'Scenario gross income' : 'Actual gross income',
      fillCb: (chart) => {
        const metasets = chart._metasets

        // If net income is hidden, enable a fill to that dataset
        // On the dashboard, We look for Actual net income, and on a scenario
        // we look for Scenario net income. 
        //
        // If they are hidden, we disable the flow. If they are not hidden, 
        // we apply fill as '-1' to income forecast. This will only fill the area
        // between the two datasets.
        const otherMetaset = metasets && metasets.find((metaset) => metaset.label === (isScenario ? 'Scenario net income' : 'Actual net income'))
        if (otherMetaset) {
          return otherMetaset.hidden ? false : '-1'
        }
        return false
      },
      borderColor: appColors.system,
      backgroundColor: hexToRGBA(appColors.red, 0.4),
      borderWidth: 3,
      showCashflowEvents: false,
      ...sharedConfig
    },
    [CHART_NAMES.EXPENSE_FORECAST]: {
      enabled: enabledStatus[CHART_NAMES.EXPENSE_FORECAST],
      label: isScenario ? 'Scenario expense' : 'Actual expense',
      fill: false,
      borderColor: appColors.system,
      borderWidth: 3,
      borderDash: [5, 5],
      showCashflowEvents: false,
      ...sharedConfig
    }
  }
  return config
}

const buildSharedConfig = () => {
  return {
    tension: 0.1,
    pointRadius: pointRadiusCallback,
    pointHoverRadius: pointRadiusCallback,
    pointBackgroundColor: pointBackgroundColorCallback,
    pointBorderColor: appColors.white,
    pointBorderWidth: 3,
    pointHoverBorderWidth: 3,
  }
}

// See: https://www.chartjs.org/docs/latest/charts/line.html#point-styling
// See: https://www.chartjs.org/docs/latest/general/options.html#scriptable-options
const pointRadiusCallback = (ctx) => {
  const cashflowEvents = get(ctx, 'dataset.showCashflowEvents', false) && get(ctx, 'raw.cashflowEvents', [])
  const cashflowEventsDrawStatus = get(ctx, 'dataset.showCashflowEvents', false) && get(ctx, 'raw.cashflowEventsDrawStatus', {})

  const  { partial, fulfilled } = cashflowEventsDrawStatus

  return some(cashflowEvents, { status: 'active' })
    ? (partial || !fulfilled) ? CHART_EVENT_ERROR_POINT_RADIUS : CHART_EVENT_POINT_RADIUS
    : 0
}

const pointBackgroundColorCallback = (ctx) => {
  const cashflowEventsDrawStatus = get(ctx, 'dataset.showCashflowEvents', false) && get(ctx, 'raw.cashflowEventsDrawStatus', {})

  const { partial, fulfilled } = cashflowEventsDrawStatus
  if (!fulfilled) {
    return appColors.red
  } else if (partial && fulfilled) {
    return appColors.warning
  } else {
    return appColors.success
  }
}
